import { api } from "./client";
import { UserLimits } from "../types/userLimits";
import { MemberShipLevel } from "../types/membershipLevel";

export const userService = () => {
    const updateUserProfile = async (userId: string, profileId: string, resumeText: string, skillsList: string[]) => {
        const { data } = await api.post("/api/users/updateprofile", { userId, profileId, resumeText, skillsList });
        if (data) {
            return data;
        }
        return null;
    }

    const loadUserResume = async (userId: string) => {
        const { data } = await api.get("/api/auth/getUserResume", { params: { userId }});
        if (data) {
            return data;
        }
        return null;
    }

    const getUserSettings = async (userId: string) => {
        const { data } = await api.get("/api/users/getsettings", { params: { userId }});
        if (data) {
            return data;
        }
    }

    const submitJobPosting = async (title: string, company: string, source: string, sourceUrl: string, postedDate: string, jobDescription: string, userId: string) => {
        const { data } = await api.post("/api/users/submitJobPosting", { title, company, source, sourceUrl, postedDate, jobDescription, userId });
        if (data) {
            return data;
        }
    }

    const updateUserPassword = async (userId: string, curPassword: string, newPassword: string) => {
        const { data } = await api.post("/api/users/updateuserpassword", { userId, curPassword, newPassword });
        if (data) {
            return data;
        }
    }

    const getAllUserResumes = async (userId: string) => {
        const { data } = await api.get(`/api/users/resumes/${userId}`);
        return data;
    }

    const createResume = async (userId: string, resumeName: string, resumeText: string, isArchived: boolean, createdBy: string, isDraft: boolean) => {
        const { data} = await api.post("/api/users/createresume", { userId, resumeName, resumeText, isArchived, createdBy, isDraft });
        return data;
    }

    const updateResume = async (resumeId: string, resumeName: string, resumeText: string, isArchived: boolean, createdBy: string, isDraft: boolean) => {
        const { data } = await api.post("/api/users/updateresume", { resumeId, resumeName, resumeText, isArchived, createdBy, isDraft });
        return data;
    }

    const deleteResume = async (resumeId: string) => {
        const { data } = await api.delete(`/api/users/removeresume/${resumeId}`);
        return data;
    }

    const saveDraftToVersion = async (userId: string, resumeVersionId: string) => {
        const { data } = await api.post("/api/users/savedrafttoversion", { userId, resumeVersionId });
        return data;
    }

    const saveDraft = async (userId: string, resumeVersionId: string, resumeText: string) => {
        const { data } = await api.post("/api/users/savedraft", { userId, resumeVersionId, resumeText });
        return data;
    }

    const saveToResume = async (userId: string, resumeName: string, resumeVersionId: string) => {
        const { data } = await api.post("/api/users/savetoresume", { userId, resumeName, resumeVersionId });
        return data;
    }

    const saveResume = async (userId: string, resumeVersionId: string) => {
        const { data } = await api.post("/api/users/saveresume", { userId, resumeVersionId });
        return data;
    }

    const getUserAnalysisUsage = async (userId: string) => {
        const response = await api.get<UserLimits>(`/api/users/getuseranalysisusage/${userId}`);
        return response.data;
    }

    const getMembershipLevels = async (): Promise<MemberShipLevel[]> => {
        const { data } = await api.get<MemberShipLevel[]>("/api/users/getMembershipLevels");
        return data;
    }

    const getUserMembershipLevel = async (userId: string): Promise<MemberShipLevel> => {
        const { data } = await api.get<MemberShipLevel>(`/api/users/getUserMembershipLevel/${userId}`);
        return data;
    }

    return {
        updateUserProfile: updateUserProfile,
        loadUserResume: loadUserResume,
        getUserSettings: getUserSettings,
        submitJobPosting: submitJobPosting,
        updateUserPassword: updateUserPassword,
        getAllUserResumes: getAllUserResumes,
        createResume: createResume,
        updateResume: updateResume,
        deleteResume: deleteResume,
        saveDraftToVersion: saveDraftToVersion,
        saveToResume: saveToResume,
        saveResume: saveResume,
        saveDraft: saveDraft,
        getUserAnalysisUsage: getUserAnalysisUsage,
        getMembershipLevels: getMembershipLevels,
        getUserMembershipLevel: getUserMembershipLevel
    }
}